import React, { useEffect, useState } from "react";
import { Answer, QuestionQuestionSelect } from "../type";

//checkboxコンポーネント
const CheckBox = ({ id, value, checked, onChange }) => {
    return (
        <input
            id={id}
            type="checkbox"
            name="inputNames"
            checked={checked}
            onChange={onChange}
            value={value}
        />
    );
};

const useDidMount = (func: Function) =>
    useEffect(() => {
        func();
    }, []);

const QuestionSelectMultiSelect: React.VFC<{
    default_next_question_no: number;
    questionSelects: QuestionQuestionSelect[];
    currentQuestionNo: number;
    required: boolean;
    dispatch: Function;
    lastAnswers: Answer[];
    isBackState: boolean;
}> = (props) => {
    const [checkedItems, setCheckedItems] = useState({});
    const [isButtonHide, setIsButtonHide] = useState(true);

    useDidMount(() => {
        if (!!lastAnswerChecked && lastAnswerChecked.length > 0) {
            setIsButtonHide(false);
        }
    });

    useEffect(() => {
        // 質問が変わった時は保持する回答はリセット
        setCheckedItems({});

        // isBackStateはヘッダーの戻るボタンを押した時にフラグが立つ
        // フラグが立った時は再度選択したいタイミングなので
        // 初期状態で何も選択されていない状態にする
        if (
            !props.isBackState &&
            !!lastAnswerChecked &&
            lastAnswerChecked.length > 0
        ) {
            let hash = {};
            lastAnswerChecked.map((a) => (hash[a] = true));
            setCheckedItems(hash);
        }
    }, [props.currentQuestionNo]);

    useEffect(() => {
        // props.requiredがtrueなら、初期表示はボタンは非表示。チェックが1つでも入ったら表示。
        // props.requiredがfalseなら、常にボタンは表示。
        if (props.required) {
            if (
                Object.values(checkedItems).some((checkedItem) => {
                    return checkedItem == true;
                })
            ) {
                setIsButtonHide(false);
            } else {
                setIsButtonHide(true);
            }
        } else {
            setIsButtonHide(false);
        }
    }, [checkedItems, props.currentQuestionNo]);

    const lastAnswerChecked: (string | number)[] =
        !!props.lastAnswers &&
        props.lastAnswers.length > 0 &&
        props.lastAnswers.map((a) => a.answer);

    const handleAnswer = (e) => {
        e.preventDefault();

        const answers = props.questionSelects.filter((qs) =>
            Object.keys(checkedItems)
                .filter((v) => checkedItems[v])
                .includes(qs.text)
        );

        props.dispatch({
            type: "MULTI_ANSWER",
            nextQuestionNo: props.default_next_question_no,
            questionNo: props.currentQuestionNo,
            answers,
        });

        setCheckedItems({}); // RESET STATE
    };

    const handleAnswerNothing = (e) => {
        e.preventDefault();

        const answers = [
            {
                text: "特になし",
                questionNo: props.currentQuestionNo,
                target1: null,
                target2: null,
                target3: null,
                target4: null,
            },
        ];

        props.dispatch({
            type: "MULTI_ANSWER",
            nextQuestionNo: props.default_next_question_no,
            questionNo: props.currentQuestionNo,
            answers,
        });

        setCheckedItems({}); // RESET STATE
    };

    const handleChange = (e) => {
        if (e.target.value == "どれもあてはまらない") {
            setCheckedItems({
                [e.target.id]: e.target.checked,
            });
        } else {
            if (checkedItems.hasOwnProperty("どれもあてはまらない")) {
                setCheckedItems({
                    [e.target.id]: e.target.checked,
                });
            } else {
                setCheckedItems({
                    ...checkedItems,
                    [e.target.id]: e.target.checked,
                });
            }
        }
    };

    let smallHeaders: string[] = [];
    const appendLabel = (questionSelect, index) => {
        if (smallHeaders.includes(questionSelect.small_header)) {
            return <></>;
        }
        smallHeaders.push(questionSelect.small_header);

        return (
            <div
                key={index + 100}
                className="QuestionSelect-SmallHeader justify-start text-xs text-black text-left mt-10 mb-4 pl-[24px] font-bold"
            >
                {questionSelect.small_header}
            </div>
        );
    };

    return (
        <form className="QuestionSelect mb-32 mt-10">
            {props.questionSelects.map((questionSelect, index) => {
                const item = questionSelect.text;

                const checked =
                    checkedItems.hasOwnProperty(item) && checkedItems[item];

                return (
                    <>
                        {!!questionSelect.small_header &&
                            appendLabel(questionSelect, index)}
                        <label
                            className={`QuestionSelectMultiSelect${
                                checked ? " Checked" : ""
                            }${
                                [17, 18, 19, 20].includes(
                                    props.currentQuestionNo
                                )
                                    ? " Option-LeftStart"
                                    : ""
                            }`}
                            htmlFor={item}
                            key={index + 1}
                        >
                            <CheckBox
                                id={item}
                                value={item}
                                onChange={handleChange}
                                checked={checked}
                            />
                            {item}
                        </label>
                    </>
                );
            })}
            {!isButtonHide &&
                [17, 18, 19, 20].includes(props.currentQuestionNo) && (
                    <div className="skrwd-Fixed-OKButton-Container">
                        {Object.keys(checkedItems).length === 0 ||
                        Object.values(checkedItems).every(
                            (v) => v === false
                        ) ? (
                            <button
                                className="skrwd-OKButton Type-White"
                                onClick={handleAnswerNothing}
                            >
                                特になし
                            </button>
                        ) : (
                            <button
                                className="skrwd-OKButton"
                                onClick={handleAnswer}
                            >
                                OK
                            </button>
                        )}
                    </div>
                )}
            {!isButtonHide &&
                ![17, 18, 19, 20].includes(props.currentQuestionNo) && (
                    <div className="skrwd-Fixed-OKButton-Container">
                        <button
                            className="skrwd-OKButton"
                            onClick={handleAnswer}
                        >
                            OK
                        </button>
                    </div>
                )}
        </form>
    );
};

export default QuestionSelectMultiSelect;
